var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"visual-list-widget",class:("" + (_vm.reversed ? 'reversed' : ''))},[_c('div',{staticClass:"inner"},[_vm._t("image"),_vm._v(" "),_c('div',{ref:"list",staticClass:"list"},[_c('div',{ref:"listInner",staticClass:"list-inner"},[_vm._t("list")],2),_vm._v(" "),_c('div',{staticClass:"gradient top"}),_vm._v(" "),_c('div',{staticClass:"gradient bottom"})])],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-48dbdde7","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./src/components/app-visual-list-widget/template.html
// module id = null
// module chunks = 